import { Alert, AlertTitle, Box } from '@mui/material';
import { MatrixCriterion, MatrixFeatureHome } from '../../../../types/advise';
import { InlineAddField } from './InlineAddField';
import { MATRIX_NAME_LIMIT } from './matrixLimits';

const calloutLead = ({ label, selected, weight }: MatrixCriterion) => {
  const share = selected
    ? `${label} carries ${weight ?? 0}% of the total score`
    : `${label} is cleared and carries no weight in the total score`;
  return `${share} but has no features behind it.`;
};

export interface NoChecklistCalloutProps {
  criterion: MatrixCriterion;
  canEdit: boolean;
  onAddFeature?: (home: MatrixFeatureHome, label: string) => Promise<string | null>;
}

export const NoChecklistCallout = ({ criterion, canEdit, onAddFeature }: NoChecklistCalloutProps) => (
  <Alert
    severity="warning"
    className="mt-3">
    <AlertTitle>No feature checklist defined for this criterion</AlertTitle>
    {calloutLead(criterion)}
    {' Define a checklist here if this criterion should factor into feature coverage.'}
    {canEdit && onAddFeature && (
      <Box className="mt-1">
        <InlineAddField
          label="Add Custom Feature"
          maxLength={MATRIX_NAME_LIMIT}
          onAdd={(label) => onAddFeature({ criterionId: criterion.id }, label)}
          buttonProps={{ variant: 'text' }}
        />
      </Box>
    )}
  </Alert>
);
